const products = [
  {
    id: 9974,
    title: "Regata Feminina Básica Canelada",
    price: "33.99",
    quantity: "300",
    description:
      "Regata feminina desenvolvida em malha canelada de viscose com elasticidade. O caimento é ajustado ao corpo com comprimento mais curto. O decote é reto e as alças são largas. Uma peça versátil como esta não pode ficar de fora dos seus melhores looks!",
    image: [
      "https://cea.vteximg.com.br/arquivos/ids/15660714-1000-1200/Regata-Feminina-Basica-Decote-Redondo-Vermelha-9647679-Vermelho_1.jpg?v=637345073390530000",
      "https://cea.vteximg.com.br/arquivos/ids/15660715-1000-1200/Regata-Feminina-Basica-Decote-Redondo-Vermelha-9647679-Vermelho_2.jpg?v=637345073394900000",
    ],
    categories: ["feminina", "esportiva", "regata"],
  },
  {
    id: 35234,
    title: "Camiseta Masculina Controles de Playstation",
    price: "39.99",
    quantity: "412",
    description:
      "Camiseta masculina desenvolvida em malha de algodão. A modelagem é ampla com caimento solto. A parte frontal tem estampa dos controles dualshock da PlayStation.",
    image: [
      "https://cea.vteximg.com.br/arquivos/ids/24200443-1000-1200/Camiseta-Masculina-Controles-de-PlayStation-Manga-Curta-Gola-Careca-Preta-9975332-Preto_1.jpg?v=637457442865170000",
      "https://cea.vteximg.com.br/arquivos/ids/24200446-1000-1200/Camiseta-Masculina-Controles-de-PlayStation-Manga-Curta-Gola-Careca-Preta-9975332-Preto_4.jpg?v=637457442875170000",
    ],
    categories: ["masculina", "camisa"],
  },
  {
    id: 23253,
    title: "Camiseta Masculina Caveira",
    price: "59.99",
    quantity: "54",
    description:
      "Camiseta masculina confeccionada em malha de algodão. Possui estampa frontal de caveira com rosa. As mangas são curtas e a gola é careca com acabamento simples.",
    image: [
      "https://cea.vteximg.com.br/arquivos/ids/24847476-1000-1200/Camiseta-Masculina-Caveira-com-Rosa-Manga-Curta-Gola-Careca-Branca-9963300-Branco_1.jpg?v=637469506693630000",
      "https://cea.vteximg.com.br/arquivos/ids/24847479-1000-1200/Camiseta-Masculina-Caveira-com-Rosa-Manga-Curta-Gola-Careca-Branca-9963300-Branco_4.jpg?v=637469506726300000",
    ],
    categories: ["masculina", "camisa"],
  },
  {
    id: 87254,
    title: "Camisa Feminina Manga Bufante",
    price: "109.99",
    quantity: "300",
    description:
      "Camisa feminina desenvolvida em tecido plano leve de viscose. A modelagem é ampla com caimento solto. A gola é esporte e a parte frontal tem fechamento por botões. As mangas são longas com volume e também têm fechamento por botões nos punhos.",
    image: [
      "https://cea.vteximg.com.br/arquivos/ids/28882824-1000-1200/Camisa-Feminina-Ampla-Manga-Bufante-Verde-Claro-9978245-Verde_Claro_1.jpg",
      "https://cea.vteximg.com.br/arquivos/ids/28882826-1000-1200/Camisa-Feminina-Ampla-Manga-Bufante-Verde-Claro-9978245-Verde_Claro_2.jpg?v=637487685902100000",
    ],
    categories: ["feminina", "camisa"],
  },
  {
    id: 34523,
    title: "Blusa Feminina Básica Cropped",
    price: "19.99",
    quantity: "123",
    description:
      "Blusa feminina desenvolvida em malha leve. A modelagem é ampla com caimento soltinho e comprimento mais curto. Possui um bolso aplicado na parte frontal. O decote é redondo com acabamento canelado e as mangas curtas com acabamento dobrado.",
    image: [
      "https://cea.vteximg.com.br/arquivos/ids/24406110-1000-1200/Blusa-Feminina-Basica-Cropped-com-Bolso-Manga-Curta-Decote-Redondo-Off-White-9883461-Off_White_1.jpg?v=637462378922730000",
      "https://cea.vteximg.com.br/arquivos/ids/24406111-1000-1200/Blusa-Feminina-Basica-Cropped-com-Bolso-Manga-Curta-Decote-Redondo-Off-White-9883461-Off_White_2.jpg?v=637462378926000000",
    ],
    categories: ["feminina", "camisa"],
  },
  {
    id: 149323,
    title: "Camiseta Masculina Esportiva",
    price: "39.99",
    quantity: "232",
    description:
      "Camiseta masculina desenvolvida em malha com leve textura que permite respiro. A parte superior tem recorte neon com aspecto de tela sobreposta. As mangas são curtas e a gola é careca. Conforto e estilo para seus treinos!.",
    image: [
      "https://cea.vtexassets.com/arquivos/ids/53347258-1600-auto?v=637807227943270000&width=1600&height=auto&aspect=true",
      "https://cea.vtexassets.com/arquivos/ids/53347257-426-512?width=426&height=512&aspect=true",
    ],
    categories: ["masculina", "camisa", "esportiva"],
  },
  {
    id: 63457,
    title: "Blusa Feminina Ombro a Ombro",
    price: "39.99",
    quantity: "232",
    description:
      "Blusa feminina desenvolvida em malha canelada de viscose com elasticidade. O caimento é ajustado ao corpo com comprimento levemente curto. Possui decote de ombro a ombro formando um V nas partes frontal e posterior.",
    image: [
      "https://cea.vteximg.com.br/arquivos/ids/34958448-1000-1200/Blusa-Feminina-Ombro-a-Ombro-Basica-Canelada-Manga-Curta-Decote-V-Branca-9980093-Branco_1.jpg?v=637520140992670000",
      "https://cea.vteximg.com.br/arquivos/ids/34958449-1000-1200/Blusa-Feminina-Ombro-a-Ombro-Basica-Canelada-Manga-Curta-Decote-V-Branca-9980093-Branco_2.jpg?v=637520140995630000",
    ],
    categories: ["feminina", "camisa"],
  },
  {
    id: 924923,
    title: "Camisa Jeans Feminina",
    price: "55.99",
    quantity: "300",
    description:
      "Regata feminina desenvolvida em malha canelada de viscose com elasticidade. O caimento é ajustado ao corpo com comprimento mais curto. O decote é reto e as alças são largas. Uma peça versátil como esta não pode ficar de fora dos seus melhores looks!",
    image: [
      "https://cea.vteximg.com.br/arquivos/ids/26315880-1000-1200/Camisa-Jeans-Feminina-Mindset-Oversized-Marmorizada-com-Bolso-Manga-Longa-Gola-Alta-Azul-Claro-9985140-Azul_Claro_1.jpg",
      "https://cea.vteximg.com.br/arquivos/ids/26315881-1000-1200/Camisa-Jeans-Feminina-Mindset-Oversized-Marmorizada-com-Bolso-Manga-Longa-Gola-Alta-Azul-Claro-9985140-Azul_Claro_2.jpg?v=637473781477700000",
    ],
    categories: ["feminina", "camisa"],
  },
  {
    id: 23425,
    title: "Blusa Feminina Básica",
    price: "29.99",
    quantity: "430",
    description:
      "Blusa feminina em malha. Decote redondo. Manga curta Muscle Tee com cavas deslocadas.",
    image: [
      "https://cea.vteximg.com.br/arquivos/ids/14581098-1000-1200/Blusa-Feminina-Basica-Manga-Curta-Decote-Redondo-Preta-9941597-Preto_1.jpg?v=637281825119200000",
      "https://cea.vteximg.com.br/arquivos/ids/14581099-1000-1200/Blusa-Feminina-Basica-Manga-Curta-Decote-Redondo-Preta-9941597-Preto_2.jpg?v=637281825130000000",
    ],
    categories: ["feminina", "camisa"],
  },
  {
    id: 63043,
    title: "Regata Masculina Esportiva",
    price: "29.99",
    quantity: "130",
    description:
      "Regata masculina desenvolvida em malha Technofit, uma malha leve que não retém calor. Sua modelagem é ampla, ideal para te deixar o mais confortável possível. As cavas e a gola careca têm acabamento em viés.",
    image: [
      "https://cea.vteximg.com.br/arquivos/ids/8707651-1000-1200/Regata-Masculina-Esportiva-Ace-Basica-Gola-Careca-Preta-8573998-Preto_1.jpg?v=636903331150770000",
      "https://cea.vteximg.com.br/arquivos/ids/8707652-1000-1200/Regata-Masculina-Esportiva-Ace-Basica-Gola-Careca-Preta-8573998-Preto_2.jpg?v=636903331160630000",
    ],
    categories: ["masculina", "esportiva", "camisa"],
  },
];

const productData = [...products, ...products];

export { productData };
